import { Modal } from '@components/alfakher/pylot-ui'
import { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'
import { Button } from '@corratech/pylot-ui'
import { DEFAULT_AGE } from '@components/checkout/DateOfBirth/DateOfBirthConfig'
import s from './AgeValidationPopup.module.scss'
import { Logo } from '@components/icons'
import { ToastType, useUI } from '@corratech/pylot-ui/context'

export const AgeValidationPopup = () => {
    const [
        isAgeVerificationPopupEnabled,
        setIsAgeVerificationPopupEnabled
    ] = useState(false)
    const { openToast } = useUI()
    const { t } = useTranslation(['common'])
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const ageAccepted = (localStorage.getItem(
                'ag_accepted'
            ) as unknown) as number
            if (!ageAccepted || findAgeDiff(ageAccepted)) {
                setIsAgeVerificationPopupEnabled(true)
            }
        }
    }, [])

    const findAgeDiff = (ageAccepted: number) => {
        const diffInMs =
            Date.now() - new Date(Number(ageAccepted) * 1000).getTime()

        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24))

        return diffInDays > 2 ? true : false
    }

    if (!isAgeVerificationPopupEnabled) return null

    return (
        <Modal
            open={isAgeVerificationPopupEnabled}
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onClose={() => {}}
            className={s.AgeValidationPopup}
        >
            <Logo />
            <div className={s.content}>
                <span className={s.bold}>
                    {t('You must be {{age}} or over to access the website.', {
                        age: DEFAULT_AGE
                    })}
                </span>
                <span>
                    {t(
                        'This website contains information about inhalation products and you need to confirm you are an adult in the United Arab Emirates who would otherwise continue to smoke or use tobacco products.\n'
                    )}
                </span>
            </div>
            <div className={s.buttons}>
                <Button
                    variant="primary"
                    onClick={() => {
                        setIsAgeVerificationPopupEnabled(false)
                        localStorage.setItem(
                            'ag_accepted',
                            String(Math.floor(Date.now() / 1000))
                        )
                    }}
                >
                    {t("I'm over {{age}}", { age: DEFAULT_AGE })}
                </Button>
                <Button
                    variant="secondary"
                    onClick={() => {
                        openToast(
                            t(
                                'You must be {{age}} or over to access the website.',
                                {
                                    age: DEFAULT_AGE
                                }
                            ),
                            ToastType.Danger,
                            false
                        )
                    }}
                >
                    {t("I'm under {{age}}", { age: DEFAULT_AGE })}
                </Button>
            </div>
        </Modal>
    )
}
